// extracted by mini-css-extract-plugin
module.exports = {"bigPictre":"_3uRiJM-o","placeholder":"jYOy60zO","action-wrapper":"_2DUxwwJd","actionWrapper":"_2DUxwwJd","discount":"_35itD69m","free-wrapper":"kO_UhKQ9","freeWrapper":"kO_UhKQ9"};